import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Departamento } from 'src/app/models/Departamento';
import { UsuarioDTO } from 'src/app/models/UsuarioDTO';

@Component({
  selector: 'perfil-usuario-page',
  templateUrl: './perfil-usuario-page.component.html',
  styleUrls: ['./perfil-usuario-page.component.scss']
})
export class PerfilUsuarioPageComponent implements OnChanges {
  @Input() usuario: UsuarioDTO;
  @Input() areasSelecionadas: Departamento[] = [];
  @Input() areas: Departamento[] = [];
  @Output() usuarioSalvo = new EventEmitter<UsuarioDTO>();

  usuarioFormGroup: FormGroup;
  fotoPerfil: string;
  timestamp = new Date().getTime();

  constructor(private fb: FormBuilder, private activeRoute: ActivatedRoute) {
    this.construirForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.usuario && changes.usuario.currentValue) {
      this.populaFormulario();
      this.fotoPerfil = this.usuario.fotoPerfil + '?v=' + this.timestamp || 'assets/avatar.png';
    }
    if (changes.areasSelecionadas && changes.areasSelecionadas.currentValue) {
      const areasSelecionadas = this.areasSelecionadas.map(area => area.id);
      this.usuarioFormGroup.get('areasInteresse').setValue(areasSelecionadas);
    }
  }

  private desabilitaCampos(): void {
    this.usuarioFormGroup.get('id').disable();
    this.usuarioFormGroup.get('login').disable();
    this.usuarioFormGroup.get('email').disable();
    this.usuarioFormGroup.get('nome').disable();
    this.usuarioFormGroup.get('telefone').disable();
    this.usuarioFormGroup.get('celular').disable();
    this.usuarioFormGroup.get('departamento').disable();
  }

  private construirForm(): void {
    this.usuarioFormGroup = this.fb.group({
      id: [''],
      login: [''],
      email: [''],
      nome: [''],
      telefone: [''],
      celular: [''],
      departamento: [''],
      areasInteresse: [[]],
      cdCliente: [''],
      consentimento: [false],
    });
    this.desabilitaCampos();
  }

  private populaFormulario(): void {
    if (this.usuario) {

      if (!this.usuario.consentimento) {
        this.usuario.consentimento = { consentimento: false }; 
      }

      this.usuarioFormGroup.patchValue({
        id: this.activeRoute.snapshot.paramMap.get('id') || '',
        login: this.usuario.login,
        email: this.usuario.email,
        nome: this.usuario.nome,
        telefone: this.usuario.telefone,
        celular: this.usuario.celular || '',
        
        departamento: this.usuario.departamento ? this.usuario.departamento.nome : '',
        cdCliente: this.usuario.cdCliente,
        consentimento: this.usuario.consentimento.consentimento || false,
      });
      
      const areasInteresseControl = this.usuarioFormGroup.get('areasInteresse');
      if (areasInteresseControl) {
        areasInteresseControl.setValue(this.usuario.areasInteresse || []);
      }
    }
  }


  updateImagemPerfil(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fotoPerfil = e.target.result;
        this.usuario.fotoPerfil = this.fotoPerfil;
      };
      reader.readAsDataURL(input.files[0]);
    }
  }


  salvarCadastro() {
    const usuarioAtualizado: UsuarioDTO = {
      ...this.usuario,
      ...this.usuarioFormGroup.value,
      consentimento: {
        consentimento: this.usuarioFormGroup.get('consentimento').value,
      }
    };

    this.usuarioSalvo.emit(usuarioAtualizado);
  }

}
